const pretupClientSpace = process.env.REACT_APP_USER_DASHBOARD;
const LoginRedirect = () => {
    window.location = `${pretupClientSpace}/login.php`;
    return null;
}

export default LoginRedirect;